<!-- <app-navbar></app-navbar> -->
<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<div class="nl-searh-container">
  <div class="nl-search-banner">
    <div>
      <h1>Hi {{username | titlecase}},</h1>
      <p>Who are you looking to hire today?</p>
    </div>
  </div>
  <div class="nl-search-box" #searchWrapper>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <div class="d-flex">
         <span class="f-12 font-weight-500 pointer"><i class="fa-solid fa-bookmark mr-2"></i> Saved Search</span>
         <span class="f-12 font-weight-500"><i class="fa-light fa-pipe mx-3"></i></span>
         <span class="f-12 font-weight-500 pointer"><i class="fa-solid fa-clock mr-2"></i>Search History</span>
        </div>
      </div>
      <div>
        <span class="f-12 font-weight-500 pointer" (click)="createProject()"><i class="fa-solid fa-plus mr-2"></i>Create Project</span>
      </div>
    </div>
    <div class="nl-search-card-top">
      <div class="d-flex justify-content-end mb-4">
        <div class="btn-search-label pointer" (click)="openIdealCandidate()">
          <i class="fa-solid fa-user-tie"></i>
          <span>Ideal Candidate</span>
        </div>
        <div class="btn-search-label pointer" (click)="openJobDescription()">
          <i class="fa-solid fa-file"></i>
          <span>Job Description </span>
        </div>
        <div class="btn-search-label pointer" (click)="openAdvancedSearch()">
          <i class="fa-solid fa-sliders"></i>
          <span>Advanced Search</span>
        </div>
      </div>
      <div class="position-relative">
        <textarea data-testid="auto-app-nl-search-textarea-1" type="text" (focus)="showList = true" class="nl-input"
          placeholder="Start typing your hiring requirement…" cols="30" rows="1" (input)="autoResize($event); onSearchInput()"
          [(ngModel)]="searchKeyword" (keydown.enter)="openSearchResult()" maxlength="2000"></textarea>

        <div class="btn-search-input pointer" (click)="searchKeyword && !inputError && openSearchResult()" [ngClass]="{'disabled-input': !searchKeyword || inputError}">
          <i class="fa-solid fa-search"></i>
        </div>
        <div class="char-count d-flex">
          <span>{{ searchKeyword?.length || 0 }}/2000</span>
          <span *ngIf="searchKeyword?.length == 2000" class="ml-2">Max characters reached</span>
        </div>
              <p *ngIf="inputError" class="text-danger f-12">Invalid input detected. Please remove any HTML tags.</p>

      </div>

    </div>
    <div class="searchlist" *ngIf="showList && !searchKeyword">
      <div class="search-placeholder">What would you like to do?</div>
      <div class="search-option">
        <div class="pointer" (click)="openAdvancedSearch()">
          <span><i class="fa-regular fa-sliders"></i></span>
          <span >Search using advanced filters</span>
        </div>
        <div (click)="createTalentpool()" class="pointer">
          <span><i class="fa-regular fa-briefcase"></i></span>
          <span>Create a new Talentpool</span>
        </div>
        <div (click)="openAdvancedSearch('keyword')" class="pointer">
          <span><i class="fa-solid fa-magnifying-glass"></i></span>
          <span>Run a keyword search</span>
        </div>
      </div>
    </div>

    <div class="searchlist" *ngIf="searchKeyword">
      <div class="search-placeholder">What would you like to do?</div>
      <div class="search-option">
        <div class="pointer d-flex" (click)="openSearchResult()" matTooltip="{{searchKeyword}}"
          [matTooltipClass]="{ 'big-tooltip text-black text-capitalize': true }" matTooltipPosition="above"
          [ngClass]="{'highlightelement': showList || showListonhover}">
          <span><i class="fa-solid fa-stars aistar"></i></span>
          <span class="ai-search-text"><span class="font-weight-600">Run a new AI search using</span> "{{ searchKeyword
            }}"</span>
        </div>
        <div class="pointer d-flex" (mouseover)="onMouseOver()" (mouseleave)="onMouseLeave()"
          (click)="openSearchResult('talent-insights')" matTooltip="{{searchKeyword}}"
          [matTooltipClass]="{ 'big-tooltip text-black text-capitalize': true }" matTooltipPosition="above">
          <span><i class="fa-solid fa-chart-line"></i></span>
          <span class="ai-search-text"><span class="font-weight-600">View talent insights for</span> "{{ searchKeyword
            }}"</span>
        </div>
        <div class="pointer d-flex" (mouseover)="onMouseOver()" (mouseleave)="onMouseLeave()"
          (click)="openAdvancedSearch('save-input')" matTooltip="{{searchKeyword}}"
          [matTooltipClass]="{ 'big-tooltip text-black text-capitalize': true }" matTooltipPosition="above">
          <span><i class="fa-solid fa-magnifying-glass"></i></span>
          <span class="ai-search-text"><span class="font-weight-600">Run a keyword search using</span> "{{ searchKeyword
            }}"</span>
        </div>
      </div>
      <div *ngIf="profiles.length > 0">
        <div class="" style="border-top: 1px solid rgba(0, 0, 0, 0.1); height: 1px;">&nbsp;</div>
        <div class="search-placeholder">Profile Matches</div>
        <div class="profile-matches__list">
          <div class="profile-match-item" [class.profile-match-item--active]="activeIndex === i"
            (mouseenter)="activeIndex = i" (mouseleave)="activeIndex = null" *ngFor="let profile of profiles; let i = index">
            <div class="pointer" (click)="openProfile(profile)">
              <p class="profile-match-item__name">{{ profile.value | titlecase }}</p>
              <p *ngIf="profile.job_title && profile.job_title.trim().length > 0" class="profile-match-item__role">{{ profile.job_title | titlecase }} <span *ngIf="profile.job_company_name && profile.job_company_name.trim().length > 0">at {{ profile.job_company_name | titlecase }}</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="nl-chip-container">
      <div class="nl-chip pointer" *ngFor="let prompt of suggestedList"
        (click)="openSearchResultWithPrompt(prompt.value)">
        <span><i class="fa-solid fa-stars"></i></span>
        <span>{{ prompt.value }}</span>
      </div>

    </div>
  </div>
  <!-- <app-talentpool-history></app-talentpool-history> -->
  <div class="d-flex align-items-start justify-content-between" style="gap:15px">
    <div class="empty-card mb-3 w-50" style="height: auto!important;">
      <div class="w-100">
        <div class="d-flex justify-content-between wccard px-3 pt-3 pb-2">
          <div class="f-14 font-weight-600"><i class="far fa-clock mr-1 f-14" style="color: #484b59;"></i> Search
            History</div>
          <span class="font-weight-500 text-webbtree-green pointer f-12" *ngIf="showHistoryViewAll?.length>5"
            (click)="viewAllHistory()">View All</span>
        </div>
        <div class="px-3 bg-white">
          <div class="" style="border-top: 1px solid rgba(0, 0, 0, 0.1); height: 1px;">&nbsp;</div>
        </div>
        <app-search-history [calledFrom]="'mainscreen'" [events]="historySubject.asObservable()"
          (viewHistoryUpdate)="checkHistory($event)"></app-search-history>
      </div>
    </div>
    <div class="empty-card mb-3 w-50" style="height: -webkit-fill-available !important;">
      <div class="w-100">
        <div class="d-flex justify-content-between pt-3 wccard px-3 pb-2">
          <div class="f-14 font-weight-600 mb-0"><i class="far fa-save mr-1 f-14 font-weight-600"
              style="color: #484b59;"></i> Saved Searches</div>
          <span class="font-weight-500 text-webbtree-green pointer f-12" *ngIf="showSavedHistoryViewAll?.length>5"
            (click)="viewAllHistory(true)">View All</span>
        </div>
        <div class="px-3 bg-white">
          <div class="" style="border-top: 1px solid rgba(0, 0, 0, 0.1); height: 1px;">&nbsp;</div>
        </div>
        <app-search-history save=true [calledFrom]="'mainscreen'" [events]="savedHistorySubject.asObservable()"
          (viewSavedHistoryUpdate)="checkHistory($event, true)"></app-search-history>
      </div>
    </div>
  </div>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
